var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 54.391,
    viewBox: "0 0 50 54.391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_130",
    "data-name": "Rectangle 130",
    width: 50,
    height: 54.391,
    fill: "#ffbf0f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    transform: "translate(4.455 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(-4.455 5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M65.851,301a2.7,2.7,0,0,1-1.643-2.809c.049-3.376.026-6.754.006-10.13,0-.525.139-.7.686-.7q13.02.024,26.04,0c.558,0,.683.2.68.709q-.026,5.145-.005,10.29A2.534,2.534,0,0,1,89.89,301Z",
    transform: "translate(-55.101 -246.605)",
    fill: "#ffbf0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M283.53,131.985a1.583,1.583,0,0,1-1.372.764,3.236,3.236,0,0,0-3.074,3.136c-.058.814-.485,1.3-1.163,1.334-.712.031-1.134-.379-1.248-1.213-.02-.14-.05-.278-.07-.418a3.231,3.231,0,0,0-3.026-2.84c-.816-.062-1.221-.326-1.4-.914a1.158,1.158,0,0,1,.868-1.462c.363-.076.742-.08,1.1-.166a3.275,3.275,0,0,0,2.458-2.758c.029-.21.058-.42.09-.63a1.177,1.177,0,0,1,2.287-.2,2.505,2.505,0,0,1,.1.571,3.228,3.228,0,0,0,3.014,3.084,1.661,1.661,0,0,1,1.434.758Z",
    transform: "translate(-233.53 -107.956)",
    fill: "#ffbf0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M283.527,245.74a1.584,1.584,0,0,1-1.232.707A3.283,3.283,0,0,0,279.156,249a7.725,7.725,0,0,0-.094.786,1.242,1.242,0,0,1-1.21,1.182,1.189,1.189,0,0,1-1.175-1.191,3.426,3.426,0,0,0-2.188-3.113,5.167,5.167,0,0,0-1.193-.239,1.19,1.19,0,0,1,.024-2.381,3.806,3.806,0,0,0,1.669-.457,3.466,3.466,0,0,0,1.686-2.843c.085-.826.485-1.2,1.195-1.194a1.177,1.177,0,0,1,1.2,1.281,3.334,3.334,0,0,0,3.2,3.2,1.391,1.391,0,0,1,1.257.757Z",
    transform: "translate(-233.527 -205.575)",
    fill: "#ffbf0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M34.7,38.564H10.923c.112-.294.348-.36.533-.47,2.809-1.687,5.616-3.377,8.436-5.045a.928.928,0,0,0,.529-.93q-.042-1.538,0-3.077a.952.952,0,0,0-.493-.905,33.907,33.907,0,0,1-7.945-7.221,17.286,17.286,0,0,1-1.56-2.4.639.639,0,0,0-.5-.408A9.829,9.829,0,0,1,2.65,12.876,20.223,20.223,0,0,1,.191,4.984C.1,4.178.021,3.366,0,2.555A2.324,2.324,0,0,1,2.523,0q20.285,0,40.57,0a2.264,2.264,0,0,1,2.439,2.368A21.253,21.253,0,0,1,42.6,13.35,9.605,9.605,0,0,1,35.644,18.1a.6.6,0,0,0-.492.339,26.425,26.425,0,0,1-7.2,7.992c-.777.614-1.589,1.187-2.407,1.747a.878.878,0,0,0-.424.834c.02,1.026.024,2.052,0,3.078a.888.888,0,0,0,.5.89q4.3,2.544,8.573,5.125c.174.1.394.164.506.457m1.72-29.807c0,1.236,0,2.473,0,3.709,0,.135-.061.311.075.4.168.1.3-.063.42-.144a5.468,5.468,0,0,0,1.468-1.44A14.094,14.094,0,0,0,40.6,5.106c.054-.337-.079-.482-.435-.477-1.079.013-2.159.018-3.239,0-.4-.008-.52.143-.514.528.018,1.2.007,2.4.006,3.6M9.118,8.8c0-1.219-.012-2.438.007-3.656.006-.393-.129-.528-.521-.52-1.044.02-2.089.025-3.132,0-.464-.012-.6.164-.527.595A16.97,16.97,0,0,0,6.293,9.827a7.066,7.066,0,0,0,2.375,2.928c.333.223.457.169.453-.243-.011-1.236,0-2.473,0-3.709",
    transform: "translate(-0.001 0.001)",
    fill: "#ffbf0f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M11.562,181.171a1.222,1.222,0,0,1-1.18,1.2,3.338,3.338,0,0,0-3.359,3.334,1.2,1.2,0,0,1-2.4.021,3.339,3.339,0,0,0-3.341-3.353,1.2,1.2,0,0,1-.021-2.392,3.338,3.338,0,0,0,3.36-3.334,1.2,1.2,0,0,1,2.4-.02,3.34,3.34,0,0,0,3.341,3.354,1.22,1.22,0,0,1,1.2,1.187",
    transform: "translate(-0.074 -150.57)",
    fill: "#ffbf0f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/cup_icon.32d5db2e0c03662e0f5623707022f223.svg";
export { ForwardRef as ReactComponent };